import { store } from 'reactApp/store';

import { getAlbumPath } from './albums.selector';

export const getAlbumsPath = (id: string) => (id === '/albums' ? '/albums/' : `/albums/${getAlbumPath(store.getState(), id)}`);
